// api/maintenance/maintenanceDocService.js

import axiosInstance from '../axiosInstance'; // Asegúrate de que esta ruta sea correcta

// Obtener todos los documentos de mantenimiento
export const fetchMaintenanceDocs = async () => {
  const response = await axiosInstance.get('/maintenance/documents'); // Ruta general para documentos
  return response.data;
};

// Obtener un documento de mantenimiento por ID
export const fetchMaintenanceDocById = async (id) => {
  const response = await axiosInstance.get(`/maintenance/documents/${id}`); // Ruta para un documento específico
  return response.data;
};

// Obtener documentos por ID de Mantenimiento
export const fetchMaintenanceDocsByMaintenanceId = async (manId) => {
  const response = await axiosInstance.get(`/maintenance/documents/maintenance/${manId}`); // Ruta para documentos de un mantenimiento
  return response.data;
};

// Subir y crear un documento de mantenimiento
export const uploadMaintenanceDoc = async (formData) => { // Espera un FormData con los datos y el archivo
  const response = await axiosInstance.post('/maintenance/documents', formData, {
    headers: {
      'Content-Type': 'multipart/form-data', // MUY IMPORTANTE para enviar archivos con Multer
    },
  });
  return response.data;
};

// Actualizar un documento de mantenimiento (puede reemplazar el archivo)
export const updateMaintenanceDoc = async ({ id, formData }) => {
  const response = await axiosInstance.put(`/maintenance/documents/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data', // MUY IMPORTANTE
    },
  });
  return response.data;
};

// Eliminar un documento de mantenimiento (físicamente)
export const deleteMaintenanceDoc = async ({ id, updbyid }) => { // Necesita 'updbyid' para el historial, aunque la eliminación sea física de la DB
  // Para DELETE con cuerpo, axios necesita el cuerpo en la propiedad 'data' de la configuración
  const response = await axiosInstance.delete(`/maintenance/documents/${id}`, { data: { updbyid } });
  return response.data;
};

// Función para obtener el archivo físico (si necesitas servirlo desde el frontend)
export const getMaintenanceDocFile = (filename) => {
  // Asegúrate de que tu backend sirva archivos desde esta URL
  // Ejemplo: http://localhost:PORT/uploads/maintenance/yourfile.pdf
  // O una ruta específica de API si tienes un controlador para servir archivos
  return `${axiosInstance.defaults.baseURL}/uploads/maintenance/${filename}`;
};